import React, { useState, useEffect } from 'react';
import { SearchIcon } from '@panwds/icons';
import { Input } from '@panwds/react-ui';
import { useFilters } from '../../hooks/useFilters/useFilters.esm.js';

function InputSearchBarFilter(props) {
    const { name, defaultValues, placeholder, disabled, id = "input-searchbar-filter", } = props;
    const { filters, setFilters } = useFilters();
    const filterValue = filters[name];
    const initialValue = filterValue || defaultValues || "";
    const [value, setValue] = useState(initialValue);
    useEffect(() => {
        setValue(initialValue);
    }, [filterValue]);
    const onInputChange = (event) => {
        setValue(event.target.value);
        setFilters({
            [name]: `${event.target.value}`,
        });
    };
    return (React.createElement("div", { id: id },
        React.createElement(Input, { dataMetrics: `filter-search-${name}`, dataTestId: `filter-search-${name}`, key: "input_search_bar", prefix: React.createElement(SearchIcon, { size: "sm", className: "tw-text-gray-600 dark:tw-text-blue-steel-300" }), placeholder: placeholder || "Search", addClassName: "tw-w-64 dark:tw-bg-gray-1050 dark:tw-border-gray-900 tw-placeholder-gray-400 dark:tw-placeholder-gray-400", disabled: disabled, value: value, onChange: onInputChange })));
}

export { InputSearchBarFilter };
//# sourceMappingURL=InputSearchBarFilter.esm.js.map
